import React from 'react';
import { css } from 'glamor';

const VerticallyCentered = props => {

  const outerWrapperStyle = css({
    display: 'table',
    width: '100%',
    height: '100%'
  });

  const innerWrapperStyle = css({
    display: 'table-cell',
    textAlign: 'center',
    verticalAlign: 'middle'
  });

  return (
    <div { ...outerWrapperStyle }>
      <div { ...innerWrapperStyle }>{ props.children }</div>
    </div>
  )
};

export default VerticallyCentered;



// WEBPACK FOOTER //
// ../src/client/components/VerticallyCentered.js